import React from "react";
import Accordion from "@material-ui/core/Accordion";
import { AccordionSummary } from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "../styles/components/accordion.css";

/**
 *
 * @param id
 * @param label
 * @param children
 * @param wrapperClassName ClassName, um den Accordion-Wrapper zu stylen
 * @param className
 * @param variant light, um ein Accordion ohne Hintergründe, Borders und Abstände zu erstellen
 * @param expandIcon Variables Expandicon
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EAAccordion({ id, label, children, wrapperClassName, className, variant, expandIcon = <ExpandMoreIcon />, ...rest }) {
    const variantStyle = variant === "light" ? " lightAccordion" : "";
    return (
        <Accordion id={id} className={wrapperClassName + variantStyle} {...rest}>
            <AccordionSummary expandIcon={expandIcon}>
                <label id={id + "-label"} htmlFor={id + "-content"}>
                    {label}
                </label>
            </AccordionSummary>
            <AccordionDetails id={id + "-content"} className={className + variantStyle}>
                {children}
            </AccordionDetails>
        </Accordion>
    );
}

EAAccordion.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(["light"]),
    defaultExpanded: PropTypes.bool,
};

export default EAAccordion;
